import { DOMINIOS_NOTAS } from './notas';

// Enumeradores numéricos espelhados nas tabelas dom_* (ver docs/convencoes/banco.md).
// Ao incluir um valor aqui, inclua também na migração da tabela correspondente.

export enum OperacaoHistorico {
  Inclusao = 1,
  Alteracao = 2,
  ExclusaoLogica = 3,
  Restauracao = 4,
  ExclusaoFisica = 5,
}

export enum OrigemRegistro {
  Usuario = 1,
  Sistema = 2,
  Ia = 3,
  Telegram = 4,
  Whatsapp = 5,
}

export enum Permissao {
  VerQuadro = 1,
  EditarProcesso = 2,
  MoverProcesso = 3,
  ArquivarProcesso = 4,
  EnviarLixeira = 5,
  EsvaziarLixeira = 6,
  EnviarDocumentos = 7,
  RevisarExtracoes = 8,
  PerguntarIa = 9,
  VerRiscos = 10,
  GerenciarLayout = 11,
  GerenciarMembros = 12,
  CriarNotasPublicas = 13,
  ConfigurarQuadro = 14,
}

export enum PerfilPadrao {
  Administrador = 1,
  Gestor = 2,
  Colaborador = 3,
  Leitor = 4,
}

export enum AppChat {
  Whatsapp = 1,
  Telegram = 2,
  Teams = 3,
  Slack = 4,
}

export enum Tabela {
  Empresa = 1,
  Usuario = 2,
  UsuarioEmpresa = 3,
  Perfil = 4,
  PerfilPermissao = 5,
  Quadro = 6,
  UsuarioQuadro = 7,
  ParametroEmpresa = 8,
  Estado = 9,
  Grupo = 10,
  Orgao = 11,
  Processo = 12,
  MotivoEstado = 13,
  Contato = 30,
  ProcessoPessoa = 31,
  Atividade = 32,
  ProcessoModuloLayout = 33,
  Nota = 34,
  NotaCompartilhamento = 35,
  Conector = 36,
  NotaAcompanhamento = 37,
  NotaAnexo = 38,
  UsuarioCanal = 39,
  RegraProvedor = 40,
  Convite = 41,
  SolicitacaoAcesso = 42,
  LicitacaoPublica = 43,
  DocumentoPublico = 44,
  Importacao = 45,
  ImportacaoArquivo = 46,
  LayoutUsuario = 47,
  Prompt = 48,
  PromptVersao = 49,
  Arquivo = 50,
  Documento = 51,
  DocumentoVersao = 52,
  ErroProvedorEnvio = 53,
}

export enum FinalidadeEstado {
  Novo = 1,
  Fluxo = 2,
  SemEstado = 3,
  Arquivo = 4,
  Lixeira = 5,
}

export enum DecisaoParticipacao {
  EmAvaliacao = 1,
  Participar = 2,
  NaoParticipar = 3,
}

export type Dominio = { nome: string; tabela: string; descricoes: Record<number, string> };

export enum EventoAcesso {
  Login = 1,
  LoginRecusado = 2,
  Logout = 3,
  RenovacaoRecusada = 4,
}

export enum MetodoAcesso {
  Senha = 1,
  Google = 2,
}

// Arquivos e documentos (migração 0005). Mesmos valores do pipeline da IA (incremento 5).
export enum FinalidadeArquivo {
  Avatar = 1,
  DocumentoProcesso = 2,
  AnexoNota = 3,
  Catalogo = 4,
  DocumentoEmpresa = 5,
  PdfDerivado = 6,
}

export enum SituacaoArquivo {
  Pendente = 1,
  /** No servidor (pasta temporária), aguardando a tarefa de envio ao S3 (migração 0022). */
  Enviando = 2,
  Disponivel = 3,
  Falhou = 4,
}

export enum EscopoDocumento {
  Processo = 1,
  Biblioteca = 2,
}

export enum TipoDocumentoIa {
  Edital = 1,
  TermoReferencia = 2,
  Anexo = 3,
  Ata = 4,
  Planilha = 5,
  Contrato = 6,
  Certidao = 7,
  Proposta = 8,
  Apoio = 9,
  Desconhecido = 10,
  EstudoTecnicoPreliminar = 11,
  MinutaContrato = 12,
  Errata = 13,
  Aviso = 14,
  Modelos = 15,
  Atestado = 16,
}

// Base comum de editais (migração 0013, ADR-0019).
export enum SituacaoLeitura {
  NaFila = 1,
  Lendo = 2,
  Analisando = 3,
  Concluido = 4,
  Falhou = 5,
}

export enum FonteLicitacao {
  EnvioEmpresa = 1,
  Pncp = 2,
}

export enum CategoriaExigencia {
  HabilitacaoJuridica = 1,
  RegularidadeFiscal = 2,
  EconomicoFinanceira = 3,
  QualificacaoTecnica = 4,
  Declaracoes = 5,
  Proposta = 6,
  Amostra = 7,
  VisitaTecnica = 8,
  Outras = 9,
}

export enum TipoPrazo {
  SessaoPublica = 1,
  EnvioProposta = 2,
  Credenciamento = 3,
  Impugnacao = 4,
  Esclarecimento = 5,
  VisitaTecnica = 6,
  Amostra = 7,
  Habilitacao = 8,
  Recurso = 9,
  Outro = 10,
}

// Envio de arquivos e vínculo ao processo (migração 0015, ADR-0020).
export enum SituacaoVinculo {
  AguardandoLeitura = 1,
  Agrupado = 2,
  Vinculado = 3,
  Sugerido = 4,
  SemIdentificacao = 5,
  Descartado = 6,
  NaoLido = 7,
}

export enum OrigemVinculo {
  Identificado = 1,
  MesmoEnvio = 2,
  Pessoa = 3,
  Cartao = 4,
  NovaLicitacao = 5,
}

// Área da licitação (migração 0005).
export enum TipoAtividade {
  Atividade = 1,
  Marco = 2,
  Entrega = 3,
}

export enum ModuloLicitacao {
  Sobre = 1,
  Pessoas = 2,
  Documentos = 3,
  Notas = 4,
  ProximosPassos = 5,
  Cronograma = 6,
  Historico = 7,
}

// Tempo real (migração 0006): o que mudou no quadro (outbox quadro_evento, ADR-0008).
export enum TipoEventoQuadro {
  Processo = 1,
  Grupo = 2,
  Licitacao = 3,
  Nota = 4,
  Conector = 5,
}

// Avisos do sistema (migração 0009). A lista cresce com os módulos (processamento, IA, mensagens).
export enum TipoNotificacao {
  ResponsavelAtividade = 1,
  AdicionadoLicitacao = 2,
  NotaCompartilhada = 3,
  PrazoVencendo = 4,
  PrazoVencido = 5,
  ProcessamentoIniciado = 6,
  ProcessamentoConcluido = 7,
  Mensagem = 8,
  ConviteAguardandoAprovacao = 9,
  ConviteDecidido = 10,
  ProcessamentoFalhou = 11,
  ConviteNaoChegou = 12,
  PapelAlterado = 13,
}

// Prompts versionados no banco (migração 0021, ADR-0010): no máximo uma versão ativa por prompt.
export enum SituacaoPrompt {
  Rascunho = 1,
  Ativa = 2,
  Arquivada = 3,
}

// Fornecedores de IA (migração 0027, ADR-0028): o prompt escolhe o fornecedor do modelo principal e da reserva.
export enum FornecedorIa {
  OpenAi = 1,
  Gemini = 2,
  Anthropic = 3,
}

// Tarefas em segundo plano no worker (migração 0022, ADR-0024).
export enum TipoTarefa {
  EnvioS3 = 1,
}

export enum SituacaoTarefa {
  Pendente = 1,
  EmAndamento = 2,
  Concluida = 3,
  Falhou = 4,
}

// Configurações da empresa (migração 0017, ADR-0022).
export enum PorteEmpresa {
  Microempresa = 1,
  PequenoPorte = 2,
  Demais = 3,
}

export enum TipoHabilitacao {
  ContratoSocial = 1,
  CartaoCnpj = 2,
  CertidaoFederal = 3,
  CertidaoEstadual = 4,
  CertidaoMunicipal = 5,
  Fgts = 6,
  Trabalhista = 7,
  Falencia = 8,
  Balanco = 9,
  Atestado = 10,
  Alvara = 11,
  Conselho = 12,
  Procuracao = 13,
  Outros = 14,
}

// Hierarquia dos convites (migração 0016, ADR-0021).
export enum SituacaoAprovacao {
  NaoExige = 1,
  Aguardando = 2,
  Aprovado = 3,
  Recusado = 4,
}

// Mensageria (migração 0011): e-mails e mensagens de chat em fila, com prioridade (menor = mais urgente).
export enum CanalEnvio {
  Email = 1,
  Chat = 2,
}

export enum ProvedorEnvio {
  Mailgun = 1,
  AmazonSes = 2,
  SendGrid = 3,
  Telegram = 4,
  WhatsApp = 5,
}

export enum SituacaoEnvio {
  Pendente = 1,
  Enviando = 2,
  Enviado = 3,
  Entregue = 4,
  Falhou = 5,
  Devolvido = 6,
  Cancelado = 7,
}

export enum TipoDestinatario {
  Para = 1,
  Copia = 2,
  CopiaOculta = 3,
}

// Tipo de cada falha de envio (migrações 0023 e 0024, RQ-MSG-008): agrupa o resumo do painel de envios. Se a falha pode ser
// tentada de novo é dito por erro de cada provedor (tabela erro_provedor_envio), não pelo tipo.
export enum TipoFalhaEnvio {
  DestinatarioInvalido = 1,
  DestinatarioRecusou = 2,
  ConteudoRecusado = 3,
  SemCanal = 4,
  ContaSuspensa = 5,
  Configuracao = 6,
  Limite = 7,
  TempoEsgotado = 8,
  Rede = 9,
  ErroProvedor = 10,
  AnexoIndisponivel = 11,
  FalhaTemporaria = 12,
  NaoClassificado = 13,
  ChaveInvalida = 14,
}

export enum TipoEventoEnvio {
  Aceito = 1,
  Entregue = 2,
  FalhaTemporaria = 3,
  FalhaDefinitiva = 4,
  Spam = 5,
  Aberto = 6,
  Clicado = 7,
  Descadastro = 8,
}

export const DOMINIOS: Dominio[] = [
  {
    nome: 'OperacaoHistorico',
    tabela: 'dom_operacao_historico',
    descricoes: {
      [OperacaoHistorico.Inclusao]: 'Inclusão',
      [OperacaoHistorico.Alteracao]: 'Alteração',
      [OperacaoHistorico.ExclusaoLogica]: 'Exclusão lógica',
      [OperacaoHistorico.Restauracao]: 'Restauração',
      [OperacaoHistorico.ExclusaoFisica]: 'Exclusão física',
    },
  },
  {
    nome: 'OrigemRegistro',
    tabela: 'dom_origem_registro',
    descricoes: {
      [OrigemRegistro.Usuario]: 'Usuário',
      [OrigemRegistro.Sistema]: 'Sistema',
      [OrigemRegistro.Ia]: 'IA',
      [OrigemRegistro.Telegram]: 'Telegram',
      [OrigemRegistro.Whatsapp]: 'WhatsApp',
    },
  },
  {
    nome: 'Permissao',
    tabela: 'dom_permissao',
    descricoes: {
      [Permissao.VerQuadro]: 'Ver quadro',
      [Permissao.EditarProcesso]: 'Criar e editar processo',
      [Permissao.MoverProcesso]: 'Mover processo e mudar estado',
      [Permissao.ArquivarProcesso]: 'Arquivar e reabrir processo',
      [Permissao.EnviarLixeira]: 'Enviar à Lixeira',
      [Permissao.EsvaziarLixeira]: 'Esvaziar Lixeira',
      [Permissao.EnviarDocumentos]: 'Enviar documentos',
      [Permissao.RevisarExtracoes]: 'Revisar extrações da IA',
      [Permissao.PerguntarIa]: 'Perguntar à IA',
      [Permissao.VerRiscos]: 'Ver riscos',
      [Permissao.GerenciarLayout]: 'Gerenciar grupos e layout',
      [Permissao.GerenciarMembros]: 'Gerenciar membros do quadro',
      [Permissao.CriarNotasPublicas]: 'Criar notas públicas',
      [Permissao.ConfigurarQuadro]: 'Configurar quadro',
    },
  },
  {
    nome: 'PerfilPadrao',
    tabela: 'dom_perfil_padrao',
    descricoes: {
      [PerfilPadrao.Administrador]: 'Administrador',
      [PerfilPadrao.Gestor]: 'Gestor',
      [PerfilPadrao.Colaborador]: 'Colaborador',
      [PerfilPadrao.Leitor]: 'Leitor',
    },
  },
  {
    nome: 'AppChat',
    tabela: 'dom_app_chat',
    descricoes: {
      [AppChat.Whatsapp]: 'WhatsApp',
      [AppChat.Telegram]: 'Telegram',
      [AppChat.Teams]: 'Microsoft Teams',
      [AppChat.Slack]: 'Slack',
    },
  },
  {
    nome: 'Tabela',
    tabela: 'dom_tabela',
    descricoes: {
      [Tabela.Empresa]: 'Empresa',
      [Tabela.Usuario]: 'Usuário',
      [Tabela.UsuarioEmpresa]: 'Vínculo de usuário com empresa',
      [Tabela.Perfil]: 'Perfil',
      [Tabela.PerfilPermissao]: 'Permissão do perfil',
      [Tabela.Quadro]: 'Quadro',
      [Tabela.UsuarioQuadro]: 'Vínculo de usuário com quadro',
      [Tabela.ParametroEmpresa]: 'Parâmetros da empresa',
      [Tabela.Estado]: 'Estado',
      [Tabela.Grupo]: 'Grupo do quadro',
      [Tabela.Orgao]: 'Órgão',
      [Tabela.Processo]: 'Processo',
      [Tabela.MotivoEstado]: 'Motivo de mudança de estado',
      [Tabela.Contato]: 'Contato externo',
      [Tabela.ProcessoPessoa]: 'Pessoa do processo',
      [Tabela.Atividade]: 'Atividade',
      [Tabela.ProcessoModuloLayout]: 'Posição de módulo da licitação',
      [Tabela.Nota]: 'Nota',
      [Tabela.NotaCompartilhamento]: 'Compartilhamento de nota',
      [Tabela.Conector]: 'Conector (seta)',
      [Tabela.NotaAcompanhamento]: 'Acompanhamento de notas privadas',
      [Tabela.NotaAnexo]: 'Anexo de nota',
      [Tabela.UsuarioCanal]: 'Canal de mensagens do usuário',
      [Tabela.RegraProvedor]: 'Regra de escolha do provedor de envio',
      [Tabela.Convite]: 'Convite para quadro',
      [Tabela.SolicitacaoAcesso]: 'Pedido de acesso',
      [Tabela.LicitacaoPublica]: 'Licitação da base comum',
      [Tabela.DocumentoPublico]: 'Documento da base comum',
      [Tabela.Importacao]: 'Importação de edital',
      [Tabela.ImportacaoArquivo]: 'Arquivo enviado',
      [Tabela.LayoutUsuario]: 'Layout de cada pessoa',
      [Tabela.Prompt]: 'Prompt da IA',
      [Tabela.PromptVersao]: 'Versão de prompt da IA',
      [Tabela.Arquivo]: 'Arquivo',
      [Tabela.Documento]: 'Documento',
      [Tabela.DocumentoVersao]: 'Versão de documento',
      [Tabela.ErroProvedorEnvio]: 'Erro de provedor de envio',
    },
  },
  {
    nome: 'FinalidadeEstado',
    tabela: 'dom_finalidade_estado',
    descricoes: {
      [FinalidadeEstado.Novo]: 'Novo',
      [FinalidadeEstado.Fluxo]: 'Fluxo',
      [FinalidadeEstado.SemEstado]: 'Sem estado',
      [FinalidadeEstado.Arquivo]: 'Arquivo',
      [FinalidadeEstado.Lixeira]: 'Lixeira',
    },
  },
  {
    nome: 'DecisaoParticipacao',
    tabela: 'dom_decisao_participacao',
    descricoes: {
      [DecisaoParticipacao.EmAvaliacao]: 'Em avaliação',
      [DecisaoParticipacao.Participar]: 'Participar',
      [DecisaoParticipacao.NaoParticipar]: 'Não participar',
    },
  },
  {
    nome: 'EventoAcesso',
    tabela: 'dom_evento_acesso',
    descricoes: {
      [EventoAcesso.Login]: 'Login',
      [EventoAcesso.LoginRecusado]: 'Login recusado',
      [EventoAcesso.Logout]: 'Saída',
      [EventoAcesso.RenovacaoRecusada]: 'Renovação de sessão recusada',
    },
  },
  {
    nome: 'MetodoAcesso',
    tabela: 'dom_metodo_acesso',
    descricoes: {
      [MetodoAcesso.Senha]: 'E-mail e senha',
      [MetodoAcesso.Google]: 'Google',
    },
  },
  {
    nome: 'FinalidadeArquivo',
    tabela: 'dom_finalidade_arquivo',
    descricoes: {
      [FinalidadeArquivo.Avatar]: 'Avatar',
      [FinalidadeArquivo.DocumentoProcesso]: 'Documento de processo',
      [FinalidadeArquivo.AnexoNota]: 'Anexo de nota',
      [FinalidadeArquivo.Catalogo]: 'Catálogo',
      [FinalidadeArquivo.DocumentoEmpresa]: 'Documento da empresa',
      [FinalidadeArquivo.PdfDerivado]: 'PDF derivado',
    },
  },
  {
    nome: 'SituacaoArquivo',
    tabela: 'dom_situacao_arquivo',
    descricoes: {
      [SituacaoArquivo.Pendente]: 'Pendente',
      [SituacaoArquivo.Enviando]: 'Enviando',
      [SituacaoArquivo.Disponivel]: 'Disponível',
      [SituacaoArquivo.Falhou]: 'Falhou',
    },
  },
  {
    nome: 'EscopoDocumento',
    tabela: 'dom_escopo_documento',
    descricoes: { [EscopoDocumento.Processo]: 'Processo', [EscopoDocumento.Biblioteca]: 'Biblioteca' },
  },
  {
    nome: 'TipoDocumentoIa',
    tabela: 'dom_tipo_documento_ia',
    descricoes: {
      [TipoDocumentoIa.Edital]: 'Edital',
      [TipoDocumentoIa.TermoReferencia]: 'Termo de referência',
      [TipoDocumentoIa.Anexo]: 'Anexo',
      [TipoDocumentoIa.Ata]: 'Ata',
      [TipoDocumentoIa.Planilha]: 'Planilha',
      [TipoDocumentoIa.Contrato]: 'Contrato',
      [TipoDocumentoIa.Certidao]: 'Certidão',
      [TipoDocumentoIa.Proposta]: 'Proposta',
      [TipoDocumentoIa.Apoio]: 'Apoio',
      [TipoDocumentoIa.Desconhecido]: 'Desconhecido',
      [TipoDocumentoIa.EstudoTecnicoPreliminar]: 'Estudo técnico preliminar',
      [TipoDocumentoIa.MinutaContrato]: 'Minuta de contrato',
      [TipoDocumentoIa.Errata]: 'Errata ou retificação',
      [TipoDocumentoIa.Aviso]: 'Aviso de licitação',
      [TipoDocumentoIa.Modelos]: 'Modelos e declarações',
      [TipoDocumentoIa.Atestado]: 'Atestado',
    },
  },
  {
    nome: 'TipoAtividade',
    tabela: 'dom_tipo_atividade',
    descricoes: { [TipoAtividade.Atividade]: 'Atividade', [TipoAtividade.Marco]: 'Marco', [TipoAtividade.Entrega]: 'Entrega' },
  },
  {
    nome: 'ModuloLicitacao',
    tabela: 'dom_modulo_licitacao',
    descricoes: {
      [ModuloLicitacao.Sobre]: 'Sobre esta licitação',
      [ModuloLicitacao.Pessoas]: 'Pessoas e contatos',
      [ModuloLicitacao.Documentos]: 'Documentos',
      [ModuloLicitacao.Notas]: 'Notas do processo',
      [ModuloLicitacao.ProximosPassos]: 'Próximos passos',
      [ModuloLicitacao.Cronograma]: 'Cronograma',
      [ModuloLicitacao.Historico]: 'Histórico de eventos',
    },
  },
  {
    nome: 'TipoEventoQuadro',
    tabela: 'dom_tipo_evento_quadro',
    descricoes: {
      [TipoEventoQuadro.Processo]: 'Processo alterado',
      [TipoEventoQuadro.Grupo]: 'Grupo alterado',
      [TipoEventoQuadro.Licitacao]: 'Licitação alterada',
      [TipoEventoQuadro.Nota]: 'Nota alterada',
      [TipoEventoQuadro.Conector]: 'Seta alterada',
    },
  },
  {
    nome: 'TipoNotificacao',
    tabela: 'dom_tipo_notificacao',
    descricoes: {
      [TipoNotificacao.ResponsavelAtividade]: 'Responsável por atividade',
      [TipoNotificacao.AdicionadoLicitacao]: 'Adicionado à licitação',
      [TipoNotificacao.NotaCompartilhada]: 'Nota compartilhada',
      [TipoNotificacao.PrazoVencendo]: 'Prazo vencendo',
      [TipoNotificacao.PrazoVencido]: 'Prazo vencido',
      [TipoNotificacao.ProcessamentoIniciado]: 'Processamento iniciado',
      [TipoNotificacao.ProcessamentoConcluido]: 'Processamento concluído',
      [TipoNotificacao.Mensagem]: 'Mensagem',
      [TipoNotificacao.ConviteAguardandoAprovacao]: 'Convite aguardando aprovação',
      [TipoNotificacao.ConviteDecidido]: 'Convite aprovado ou recusado',
      [TipoNotificacao.ProcessamentoFalhou]: 'Processamento com falha',
      [TipoNotificacao.ConviteNaoChegou]: 'Convite não chegou',
      [TipoNotificacao.PapelAlterado]: 'Papel no quadro alterado',
    },
  },
  {
    nome: 'SituacaoPrompt',
    tabela: 'dom_situacao_prompt',
    descricoes: { [SituacaoPrompt.Rascunho]: 'Rascunho', [SituacaoPrompt.Ativa]: 'Ativa', [SituacaoPrompt.Arquivada]: 'Arquivada' },
  },
  {
    nome: 'FornecedorIa',
    tabela: 'dom_fornecedor_ia',
    descricoes: { [FornecedorIa.OpenAi]: 'OpenAI', [FornecedorIa.Gemini]: 'Google Gemini', [FornecedorIa.Anthropic]: 'Anthropic' },
  },
  {
    nome: 'TipoTarefa',
    tabela: 'dom_tipo_tarefa',
    descricoes: { [TipoTarefa.EnvioS3]: 'Envio de documento ao S3' },
  },
  {
    nome: 'SituacaoTarefa',
    tabela: 'dom_situacao_tarefa',
    descricoes: {
      [SituacaoTarefa.Pendente]: 'Pendente',
      [SituacaoTarefa.EmAndamento]: 'Em andamento',
      [SituacaoTarefa.Concluida]: 'Concluída',
      [SituacaoTarefa.Falhou]: 'Falhou',
    },
  },
  {
    nome: 'CanalEnvio',
    tabela: 'dom_canal_envio',
    descricoes: { [CanalEnvio.Email]: 'E-mail', [CanalEnvio.Chat]: 'Mensagem de chat' },
  },
  {
    nome: 'ProvedorEnvio',
    tabela: 'dom_provedor_envio',
    descricoes: {
      [ProvedorEnvio.Mailgun]: 'Mailgun',
      [ProvedorEnvio.AmazonSes]: 'Amazon SES',
      [ProvedorEnvio.SendGrid]: 'SendGrid',
      [ProvedorEnvio.Telegram]: 'Telegram',
      [ProvedorEnvio.WhatsApp]: 'WhatsApp',
    },
  },
  {
    nome: 'SituacaoEnvio',
    tabela: 'dom_situacao_envio',
    descricoes: {
      [SituacaoEnvio.Pendente]: 'Pendente',
      [SituacaoEnvio.Enviando]: 'Enviando',
      [SituacaoEnvio.Enviado]: 'Enviado',
      [SituacaoEnvio.Entregue]: 'Entregue',
      [SituacaoEnvio.Falhou]: 'Falhou',
      [SituacaoEnvio.Devolvido]: 'Devolvido',
      [SituacaoEnvio.Cancelado]: 'Cancelado',
    },
  },
  {
    nome: 'TipoDestinatario',
    tabela: 'dom_tipo_destinatario',
    descricoes: { [TipoDestinatario.Para]: 'Para', [TipoDestinatario.Copia]: 'Cópia', [TipoDestinatario.CopiaOculta]: 'Cópia oculta' },
  },
  {
    nome: 'TipoFalhaEnvio',
    tabela: 'dom_tipo_falha_envio',
    descricoes: {
      [TipoFalhaEnvio.DestinatarioInvalido]: 'Destinatário inexistente ou inválido',
      [TipoFalhaEnvio.DestinatarioRecusou]: 'Destinatário recusou',
      [TipoFalhaEnvio.ConteudoRecusado]: 'Conteúdo recusado',
      [TipoFalhaEnvio.SemCanal]: 'Pessoa sem canal vinculado',
      [TipoFalhaEnvio.ContaSuspensa]: 'Falta de pagamento ou conta suspensa',
      [TipoFalhaEnvio.Configuracao]: 'Configuração do provedor',
      [TipoFalhaEnvio.Limite]: 'Limite de envio do provedor',
      [TipoFalhaEnvio.TempoEsgotado]: 'Tempo esgotado',
      [TipoFalhaEnvio.Rede]: 'Falha de rede',
      [TipoFalhaEnvio.ErroProvedor]: 'Erro do servidor do provedor',
      [TipoFalhaEnvio.AnexoIndisponivel]: 'Anexo indisponível',
      [TipoFalhaEnvio.FalhaTemporaria]: 'Falha temporária do destinatário',
      [TipoFalhaEnvio.NaoClassificado]: 'Não classificado',
      [TipoFalhaEnvio.ChaveInvalida]: 'Chave ou credencial inválida',
    },
  },
  {
    nome: 'TipoEventoEnvio',
    tabela: 'dom_tipo_evento_envio',
    descricoes: {
      [TipoEventoEnvio.Aceito]: 'Aceito pelo provedor',
      [TipoEventoEnvio.Entregue]: 'Entregue',
      [TipoEventoEnvio.FalhaTemporaria]: 'Falha temporária',
      [TipoEventoEnvio.FalhaDefinitiva]: 'Falha definitiva (devolvido)',
      [TipoEventoEnvio.Spam]: 'Marcado como spam',
      [TipoEventoEnvio.Aberto]: 'Aberto',
      [TipoEventoEnvio.Clicado]: 'Clicado',
      [TipoEventoEnvio.Descadastro]: 'Descadastro',
    },
  },
  {
    nome: 'SituacaoLeitura',
    tabela: 'dom_situacao_leitura',
    descricoes: {
      [SituacaoLeitura.NaFila]: 'Na fila',
      [SituacaoLeitura.Lendo]: 'Lendo',
      [SituacaoLeitura.Analisando]: 'Analisando',
      [SituacaoLeitura.Concluido]: 'Concluído',
      [SituacaoLeitura.Falhou]: 'Falhou',
    },
  },
  {
    nome: 'FonteLicitacao',
    tabela: 'dom_fonte_licitacao',
    descricoes: { [FonteLicitacao.EnvioEmpresa]: 'Enviado por empresa', [FonteLicitacao.Pncp]: 'PNCP' },
  },
  {
    nome: 'CategoriaExigencia',
    tabela: 'dom_categoria_exigencia',
    descricoes: {
      [CategoriaExigencia.HabilitacaoJuridica]: 'Habilitação jurídica',
      [CategoriaExigencia.RegularidadeFiscal]: 'Regularidade fiscal, social e trabalhista',
      [CategoriaExigencia.EconomicoFinanceira]: 'Qualificação econômico-financeira',
      [CategoriaExigencia.QualificacaoTecnica]: 'Qualificação técnica',
      [CategoriaExigencia.Declaracoes]: 'Declarações',
      [CategoriaExigencia.Proposta]: 'Proposta',
      [CategoriaExigencia.Amostra]: 'Amostra ou prova de conceito',
      [CategoriaExigencia.VisitaTecnica]: 'Visita técnica',
      [CategoriaExigencia.Outras]: 'Outras',
    },
  },
  {
    nome: 'TipoPrazo',
    tabela: 'dom_tipo_prazo',
    descricoes: {
      [TipoPrazo.SessaoPublica]: 'Sessão pública',
      [TipoPrazo.EnvioProposta]: 'Envio de proposta',
      [TipoPrazo.Credenciamento]: 'Credenciamento',
      [TipoPrazo.Impugnacao]: 'Impugnação',
      [TipoPrazo.Esclarecimento]: 'Esclarecimento',
      [TipoPrazo.VisitaTecnica]: 'Visita técnica',
      [TipoPrazo.Amostra]: 'Amostra',
      [TipoPrazo.Habilitacao]: 'Habilitação',
      [TipoPrazo.Recurso]: 'Recurso',
      [TipoPrazo.Outro]: 'Outro',
    },
  },
  {
    nome: 'PorteEmpresa',
    tabela: 'dom_porte_empresa',
    descricoes: {
      [PorteEmpresa.Microempresa]: 'Microempresa (ME)',
      [PorteEmpresa.PequenoPorte]: 'Empresa de pequeno porte (EPP)',
      [PorteEmpresa.Demais]: 'Demais (sem enquadramento)',
    },
  },
  {
    nome: 'TipoHabilitacao',
    tabela: 'dom_tipo_habilitacao',
    descricoes: {
      [TipoHabilitacao.ContratoSocial]: 'Contrato social e alterações',
      [TipoHabilitacao.CartaoCnpj]: 'Cartão CNPJ',
      [TipoHabilitacao.CertidaoFederal]: 'Certidão federal (Receita e PGFN)',
      [TipoHabilitacao.CertidaoEstadual]: 'Certidão estadual',
      [TipoHabilitacao.CertidaoMunicipal]: 'Certidão municipal',
      [TipoHabilitacao.Fgts]: 'Certificado de regularidade do FGTS',
      [TipoHabilitacao.Trabalhista]: 'Certidão negativa de débitos trabalhistas',
      [TipoHabilitacao.Falencia]: 'Certidão de falência e recuperação judicial',
      [TipoHabilitacao.Balanco]: 'Balanço patrimonial',
      [TipoHabilitacao.Atestado]: 'Atestado de capacidade técnica',
      [TipoHabilitacao.Alvara]: 'Alvará de funcionamento',
      [TipoHabilitacao.Conselho]: 'Registro em conselho profissional',
      [TipoHabilitacao.Procuracao]: 'Procuração',
      [TipoHabilitacao.Outros]: 'Outros',
    },
  },
  {
    nome: 'SituacaoAprovacao',
    tabela: 'dom_situacao_aprovacao',
    descricoes: {
      [SituacaoAprovacao.NaoExige]: 'Não exige aprovação',
      [SituacaoAprovacao.Aguardando]: 'Aguardando aprovação',
      [SituacaoAprovacao.Aprovado]: 'Aprovado',
      [SituacaoAprovacao.Recusado]: 'Recusado',
    },
  },
  {
    nome: 'SituacaoVinculo',
    tabela: 'dom_situacao_vinculo',
    descricoes: {
      [SituacaoVinculo.AguardandoLeitura]: 'Aguardando leitura',
      [SituacaoVinculo.Agrupado]: 'Agrupado',
      [SituacaoVinculo.Vinculado]: 'Vinculado',
      [SituacaoVinculo.Sugerido]: 'Sugerido',
      [SituacaoVinculo.SemIdentificacao]: 'Sem identificação',
      [SituacaoVinculo.Descartado]: 'Descartado',
      [SituacaoVinculo.NaoLido]: 'Não foi possível ler',
    },
  },
  {
    nome: 'OrigemVinculo',
    tabela: 'dom_origem_vinculo',
    descricoes: {
      [OrigemVinculo.Identificado]: 'Identificado pelo conteúdo',
      [OrigemVinculo.MesmoEnvio]: 'Mesmo envio',
      [OrigemVinculo.Pessoa]: 'Escolhido pela pessoa',
      [OrigemVinculo.Cartao]: 'Enviado no cartão',
      [OrigemVinculo.NovaLicitacao]: 'Nova licitação pela pessoa',
    },
  },
  ...DOMINIOS_NOTAS,
];
